export default "__VITE_ASSET__BnRJesok__"